import { post } from 'src/api/api';
import {
  MobileOperatingSystem,
  getMobileOperatingSystem,
} from 'src/utils/get-mobile-operating-system';

import { ANALYTICS_ENDPOINT_V2 } from '@features/Analytics/constants';
import { createTestSegmentFromQueryParameters } from '@features/Analytics/utils';

export const sendAnalyticsId = async ({
  googlePseudoId,
  userPseudoIdApplePay,
  userPseudoIdWinback,
  mg,
}: {
  googlePseudoId?: string;
  userPseudoIdApplePay?: string;
  userPseudoIdWinback?: string;
  mg: number | string;
}) =>
  await post({
    endpoint: ANALYTICS_ENDPOINT_V2,
    path: 'id_aggregator',
    body: {
      user_pseudo_id: googlePseudoId,
      origin: 'youth',
      mg: mg,
      user_pseudo_id_apple_pay: userPseudoIdApplePay,
      user_pseudo_id_winback: userPseudoIdWinback,
    },
  });

export const getAbTests = async ({
  variant,
  utm_source,
  utm_campaign,
  region,
  user_id,
  abortSignal,
}: {
  variant: string | undefined;
  utm_source: string | undefined;
  utm_campaign: string | undefined;
  region: string | undefined;
  user_id: string | undefined;
  abortSignal?: AbortSignal;
}) => {
  const isAndroidDevice =
    getMobileOperatingSystem() === MobileOperatingSystem.ANDROID
      ? 'android'
      : '';
  const isIosDevise =
    getMobileOperatingSystem() === MobileOperatingSystem.IOS ? 'ios' : '';

  const pseudoData = createTestSegmentFromQueryParameters();

  if (pseudoData) {
    return pseudoData;
  }

  const params = new URLSearchParams({
    variant: variant || '',
    utm_source: utm_source || '',
    utm_campaign: utm_campaign || '',
    region: region || '',
    user_id: user_id || '',
    os: isAndroidDevice || isIosDevise || '',
  });

  const response = await fetch(`/api/abtests?${params}`, {
    method: 'GET',
    signal: abortSignal,
  });

  if (!response.ok) {
    throw new Error(`AB Tests API error: ${response.status}`);
  }

  return await response.json();
};
